import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Developer with apps up on the ios and google play stores.`}</p>
    </blockquote>
    <p>{`I'm in the greater NYC area. Currently working full time as a Frontend Developer at Spotify.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      